import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import LiveInfo from './LiveInfo'
import PackageModal from './PackageModal'
import CaseModal from './CaseModal'
import Poster from './Poster'
import BetterModal from './BetterModal'
import { LIVE_MANAGE_PATH } from '@constant'
import { Alert } from 'hljd'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    const {
      params: { id }
    } = props
    this.current_id = id
  }

  render() {
    /**
     * 审核状态 1未编辑 2待审核 3审核通过 4审核拒绝
     */
    const {
      packageModalStatus,
      caseModalStatus,
      auditing_remark,
      status,
      closeCaseModal,
      caseList,
      saveCase
    } = this.store
    const showStatus = +status === 3 || +status === 4
    const title = showStatus
      ? '审核结果'
      : this.current_id
        ? '编辑直播'
        : '新增直播'
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, title]
    return (
      <HeaderView header={header} title={title}>
        {showStatus &&
          (status == 4 ? (
            <Alert
              style={{ marginTop: 20, color: '#FF801A' }}
              message={`审核未通过，${auditing_remark}`}
              type="warning"
              showIcon
            />
          ) : (
            <Alert
              style={{ marginTop: 20, color: '#2fc286' }}
              message="审核通过"
              type="success"
              showIcon
            />
          ))}
        <LiveInfo store={this.store} {...this.props} />
        {packageModalStatus && <PackageModal store={this.store} />}
        <CaseModal
          caseModalStatus={caseModalStatus}
          closeCaseModal={closeCaseModal}
          caseList={caseList}
          saveCase={saveCase}
        />
        <BetterModal store={this.store} />
        <Poster />
      </HeaderView>
    )
  }
}
